import { IS_OFFLINE } from '../constants/actionTypes';
import { IsOfflineActionTypes } from '../types';

export const updateOffline = (offline: boolean): IsOfflineActionTypes => ({
  type: IS_OFFLINE,
  payload: offline,
});
